module.exports = __webpack_public_path__ + "img/module0.a8d66d1e.png";